var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/created") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/created",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8147278,6.37054446 L7.29216173,6.37054446 C6.57852051,6.37054446 6,6.94906497 6,7.66270619 L6,16.7078383 C6,17.4214795 6.57852051,18 7.29216173,18 L16.3372938,18 C17.050935,18 17.6294555,17.4214795 17.6294555,16.7078383 L17.6294555,12.1852722",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6603342,5.40142316 C17.1955652,4.86619227 18.0633459,4.86619228 18.5985768,5.40142318 C19.1338077,5.93665409 19.1338077,6.80443484 18.5985768,7.33966575 L12.4608086,13.477434 L9.87648518,14.1235148 L10.522566,11.5391914 L16.6603342,5.40142316 Z",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/created.9888be8129b5d694c38f983aa6696272.svg";
export { ForwardRef as ReactComponent };